import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { Image } from 'expo-image';
import { useAgentStore } from '@/store';
import Icon from '@/components/Icon';
import { useTheme } from '@/context/ThemeContext';

// Multiple history surfaces can show the same bot at once.
const pending = new Map();

function BotAvatar({ agentId }) {
  const agent = useAgentStore(state => state.agents[agentId]);
  const { colors } = useTheme();
  const [failedSource, setFailedSource] = useState(null);
  useEffect(() => {
    if (!agentId || agent) return;
    if (!pending.has(agentId)) {
      const request = useAgentStore.getState().fetchAgentById(agentId)
        .catch(() => {}).finally(() => pending.delete(agentId));
      pending.set(agentId, request);
    }
  }, [agentId, agent]);
  if (!agentId) return null;
  const source = agent?.avatarPath;
  return (
    <View accessible accessibilityRole="image" accessibilityLabel={agent?.name || 'Bot'}
      style={{ width: 22, height: 22, borderRadius: 11, overflow: 'hidden', flexShrink: 0,
        alignItems: 'center', justifyContent: 'center', marginRight: 8,
        backgroundColor: colors.solid_color_tertiary }}>
      {source && source !== failedSource ? (
        <Image accessibilityLabel="" source={{ uri: source }} contentFit="cover" accessible={false}
          style={{ width: 22, height: 22 }} onError={() => setFailedSource(source)} />
      ) : <Icon name="robot" size={13} color={colors.text_color_tertiary} />}
    </View>
  );
}

export default function ChatBotAvatar({ agentId }) {
  return agentId ? <BotAvatar agentId={agentId} /> : null;
}
